import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User opened the video transcript',
  name: 'opened_transcript',
  params: [
    {
      description: 'The ID of the clip',
      name: 'id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
